import { createSlice } from '@reduxjs/toolkit';
import { selectedDate } from './selectedDateUtils';
import { selectedDateInitialStateValue, selectedDateSliceName } from './selectedDateInitialState';

export const selectedDateSlice = createSlice({
  name: selectedDateSliceName,
  initialState: selectedDateInitialStateValue,
  reducers: {
    setSelectedDate: selectedDate,
  },
});

export const { setSelectedDate } = selectedDateSlice.actions;

export default selectedDateSlice.reducer;
